module.exports = __webpack_public_path__ + "img/icon-message.297290d6.svg";